import React from 'react';
import { FrameContainer } from '../styledComponents/layout';

const NotFoundPage = () => (
  <FrameContainer>
    <h1>404 Not Found</h1>
    <p>申し訳ございません。お探しのページは見つかりませんでした。</p>
  </FrameContainer>
);

export default NotFoundPage;



// WEBPACK FOOTER //
// ./src/pages/404.js